var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCompanyBenefitDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4001_20035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8418 18.6215C22.8418 11.5638 15 6.07458 15 6.07458C15 6.07458 7.1582 11.5638 7.1582 18.6215C7.1582 20.7012 7.98439 22.6958 9.45501 24.1664C10.9256 25.6371 12.9202 26.4633 15 26.4633C17.0798 26.4633 19.0744 25.6371 20.545 24.1664C22.0156 22.6958 22.8418 20.7012 22.8418 18.6215Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7852 23.3267C17.7456 22.9963 19.3738 21.3662 19.7061 19.4058",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_20035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCompanyBenefitDrop);
export default __webpack_public_path__ + "static/media/mobile-company-benefit-drop.68147d01c324b472ad1e37d07dbb33b8.svg";
export { ForwardRef as ReactComponent };